import { SetStateAction, useCallback, useEffect } from "react";
import { Progress } from "antd";
import "./scoreBoard.scss";
import WellBeEMPIService from "@services/empiService.service";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import { getProgressColorCode } from "@pages/utils/utils";
import { isEmpty } from "lodash";
import DataNotFound from "@components/noDataFound";

const ScoreBoard = ({setTableLoader}:any) => {
  // importing states from the store
  const scoreBoardValue = useDataQualityReportStore((state) => state.scoreBoardValue);
  const payer = useDataQualityReportStore((state) => state.payer);
  const fileType = useDataQualityReportStore((state) => state.fileType);
  const selectedDateRange = useDataQualityReportStore((state) => state.selectedDateRange);
  const selectedScoreType = useDataQualityReportStore((state) => state.selectedScoreType);
  const setSelectedScoreType = useDataQualityReportStore((state) => state.setSelectedScoreType);
  const setDataDetails = useDataQualityReportStore((state) => state.setDataDetails);
  const setLoadingForCardOrTableView = useDataQualityReportStore((state) => state.setLoadingForCardOrTableView);
  const failedFilesType = useDataQualityReportStore((state) => state.failedFilesType);

  const fetchTableOrCardViewData = (payer: any, fileType: any, dateRange: any, selectedScoreType: any, failedFilesType: any) => {
    if (!isEmpty(payer) && !isEmpty(fileType) && dateRange && selectedScoreType?.id) {
      setLoadingForCardOrTableView(true);
      setDataDetails([]);
      setTableLoader(true);
      WellBeEMPIService.getScoreAnomalyData(payer, fileType, dateRange?.startDate, dateRange?.endDate, selectedScoreType?.id, failedFilesType).subscribe({
        next: (response: any) => {
          const result = response?.data?.data?.records || [];
          setDataDetails(result);
          setLoadingForCardOrTableView(false);
          setTableLoader(false);
        },
        error: (error) => {
          setLoadingForCardOrTableView(false);
          setTableLoader(false);
          setDataDetails([]);
        },
      });
    }
  };

  useEffect(() => {
    fetchTableOrCardViewData(payer, fileType, selectedDateRange, selectedScoreType, failedFilesType);
  }, [selectedScoreType, payer, fileType, selectedDateRange, failedFilesType]);

  const scoreTitleFormat = (percent: any, label: any) => (
    <div className="score-board__total-score__inner">
      <span className="score-board__total-score__inner__percent">{percent}%</span>
      <span className="score-board__total-score__inner__label">
        <span>{label}</span>
      </span>
    </div>
  );

  const handleItemClick = (item: SetStateAction<number>) => {
    setSelectedScoreType(item);
  };

  return (
    <div className="score-board">
      {/* Overall Score */}
      {scoreBoardValue &&
        scoreBoardValue.map((scoreItem: any, index: any) =>
          scoreItem.id === "Overall" ? (
            <div className="score-board__total-score" key={index}>
              <Progress type="circle" percent={scoreItem.value} strokeColor={getProgressColorCode(scoreItem.color)} format={() => scoreTitleFormat(scoreItem.value, scoreItem.label)} width={150} />
            </div>
          ) : null
        )}

      {/* Other Scores */}
      <div className="score-board__list">
        {scoreBoardValue &&
          scoreBoardValue.map((scoreItem: any, index: any) =>
            scoreItem.id !== "Overall" ? (
              <div className={`score-board__list__item ${selectedScoreType?.id === scoreItem.id ? "score-board__list__item--selected" : ""}`} key={index} onClick={() => handleItemClick(scoreItem)}>
                <span className="score-board__list__item__title">
                  <span style={{ fontWeight: "500" }}>{scoreItem.label}</span>
                  <span>{scoreItem.value}%</span>
                </span>
                <Progress percent={parseInt(scoreItem.value, 10)} strokeColor={getProgressColorCode(scoreItem.color)} showInfo={false} />
              </div>
            ) : null
          )}
      </div>

      {isEmpty(scoreBoardValue) && <DataNotFound message={"No Data Found"} />}
    </div>
  );
};

export default ScoreBoard;
